import './IconMiniWarning.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconMiniWarning = function IconMiniWarning(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 22.348 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    className = _ref.className,
    fill = _ref.fill;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 22.348 20",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.912,25H3.592a2.471,2.471,0,0,1-2.243-1.117,2.471,2.471,0,0,1,.154-2.5l8.659-15A2.473,2.473,0,0,1,12.252,5a2.472,2.472,0,0,1,2.089,1.384l8.659,15a2.471,2.471,0,0,1,.155,2.5A2.472,2.472,0,0,1,20.912,25ZM12.252,6.82c-.119,0-.323.146-.512.474l-8.66,15c-.189.327-.214.578-.154.68s.288.206.667.206H20.912c.378,0,.607-.1.667-.207s.034-.353-.155-.68l-8.659-15C12.575,6.967,12.371,6.82,12.252,6.82Z",
    transform: "translate(-1.078 -5)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.207 16.047) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.183 3.141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.913,0A.93.93,0,0,0,0,.947V5.122a.93.93,0,0,0,.913.947.93.93,0,0,0,.913-.947V.947A.93.93,0,0,0,.913,0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "1.095",
    cy: "1.095",
    r: "1.095",
    fill: "currentColor"
  }))));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1p2armp"
});
export default IconMiniWarning;